import React from "react";
import { Box, Typography } from "@mui/material";
import { useModalStyles } from "../common/useModalStyles";

interface ContentSectionProps {
  icon?: React.ReactNode;
  iconColor?: string;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  onHeaderClick?: () => void;
}

export const SectionHeader: React.FC<ContentSectionProps> = ({
  icon,
  iconColor,
  title,
  subtitle,
  action,
  onHeaderClick
}) => {
  const { tokens, iconBoxSx } = useModalStyles();
  const color = iconColor ?? tokens.accent;

  return (
    <Box
      display="flex"
      alignItems={subtitle ? "flex-start" : "center"}
      justifyContent="space-between"
      onClick={onHeaderClick}
      sx={{
        px: 2.8,
        pt: 1.4,
        pb: 1.2,
        borderBottom: `1px solid ${tokens.border}`,
        backgroundColor: tokens.headerFooterBg,
        flexShrink: 0,
        gap: 1.5,
        ...(onHeaderClick && {
          cursor: "pointer",
          transition: "background-color 0.15s",
          "&:hover": { backgroundColor: `${tokens.accent}0d` },
        }),
      }}
    >
      <Box display="flex" alignItems={subtitle ? "flex-start" : "center"} gap={1.4} minWidth={0}>
        {icon && (
          <Box sx={{ ...iconBoxSx(color), width: 36, height: 36, borderRadius: "10px", flexShrink: 0 }}>
            <Box sx={{ color, display: "flex", alignItems: "center", "& svg": { fontSize: "1.05rem" } }}>
              {icon}
            </Box>
          </Box>
        )}
        <Box minWidth={0}>
          <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: tokens.textPrimary, lineHeight: 1.25 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: "0.8rem", color: tokens.textSecondary, mt: 0.15, lineHeight: 1.35 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>

      {action}
    </Box>
  );
};
